export const List = ({ content }: { content: Array<string> }) => (
  <ul className="para-font-lg font-medium list-disc text-font-550 ml-10 my-5">
    {content.map((liEle, index) => (
      <li key={index}>{liEle}</li>
    ))}
  </ul>
);
